var _path, _path2, _path3, _circle, _path4, _path5, _rect, _rect2, _rect3, _rect4, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMascotReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 125,
    viewBox: "0 0 75 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.4394 117.288C74.257 116.056 75 113.346 75 110.882V81.0277C74.8918 63.2377 63.8309 50.3512 44.7619 50.4677L40.1582 50.496C23.7357 51.073 22.6209 71.6813 21.0465 68.2316C19.4721 64.7818 20.0354 47.2423 19.9318 45.1592C19.8968 44.4559 19.309 42.704 18.0837 42.6872C17.3459 42.6771 16.4097 43.0611 16.4097 44.8634C14.9031 44.5286 12.2247 45.533 11.4597 46.7272C10.6948 47.9214 9.67615 59.2716 12.3515 69.3516C15.0269 79.4317 18.817 80.7758 20.6144 80.7758C22.4117 80.7758 23.053 80.4174 23.9448 79.0733C24.8366 77.7293 25.9514 76.6093 26.8569 76.6093C27.9717 76.6093 27.7434 78.1836 27.7487 79.0733V120.338C27.7487 121.364 28.4411 122.261 29.4349 122.495C35.1021 123.825 40.7711 124.582 46.939 124.545C51.4228 124.518 55.4001 124.111 59.5516 123.358C60.6018 123.168 61.3517 122.238 61.3449 121.166L61.1025 82.9187C61.0962 81.8811 62.2605 81.0344 63.3729 81.0277C64.4852 81.0205 65.6599 81.8565 65.6662 82.8941L65.8966 118.317C65.9059 119.775 67.2284 120.6 68.6686 120.42C69.8722 120.27 71.6558 119.976 73.4394 117.288Z",
    fill: "#5C4691"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5112 20.7507C23.5168 33.0216 32.4731 43.6499 44.5161 44.4898C56.559 45.3294 67.7033 36.0593 68.6979 23.7884C69.6924 11.5175 60.1605 0.892687 48.1177 0.0528614C36.0749 -0.786965 25.506 8.47976 24.5112 20.7507Z",
    fill: "#5C4691"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5336 38.3199C52.3666 37.3407 52.4823 34.9446 52.7052 33.6006C52.9282 32.2566 52.7052 31.8085 52.0364 32.0325C51.3676 32.2566 50.9217 33.8246 48.0233 34.9446C45.125 36.0646 43.7873 35.8406 42.6726 35.8406C41.5578 35.8406 41.5578 36.5126 42.8955 37.6326C44.2332 38.7527 46.6856 38.792 48.5336 38.3199Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.52505,
    cy: 25.8854,
    r: 5.85903,
    fill: "#F6CF94"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00977 29.0664H11.7058L10.3362 33.4188H6.37941L5.00977 29.0664Z",
    fill: "#F6CF94"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34766 33.4185H10.3653L9.69567 36.0969H7.13901L6.34766 33.4185Z",
    fill: "#D9D9D9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.31934,
    y: 16.0728,
    width: 1.00441,
    height: 3.04319,
    rx: 0.502203,
    transform: "rotate(-30 3.31934 16.0728)",
    fill: "#FFB84E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 18.8882,
    width: 1.00441,
    height: 3.10173,
    rx: 0.502203,
    transform: "rotate(-60 0 18.8882)",
    fill: "#FFB84E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.02148,
    y: 14,
    width: 1.00441,
    height: 4.01762,
    rx: 0.502203,
    fill: "#FFB84E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.8857,
    y: 15.7485,
    width: 1.00441,
    height: 3.03094,
    rx: 0.502203,
    transform: "rotate(30 12.8857 15.7485)",
    fill: "#FFB84E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 16.4053,
    y: 18.3047,
    width: 1.00441,
    height: 3.10791,
    rx: 0.502203,
    transform: "rotate(60 16.4053 18.3047)",
    fill: "#FFB84E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascotReport);
export default __webpack_public_path__ + "static/media/mascotReport.bc2db919878c84761f1e4429c75c1a56.svg";
export { ForwardRef as ReactComponent };